<!-- 个人信息 弹窗 -->
<template>
  <lzd-modal
    title="个人信息"
    v-model="visible"
    @closed="handleClosed"
    style="max-width: 90%; padding: 0"
    :body-style="{
      padding: 0,
      background: 'var(--ele-layout-bg)',
      minHeight: '100%'
    }"
    :size="1200"
    :direction="'rtl'"
    :withHeader="true"
    :inner="false"
  >
    <el-alert
      v-if="missingFields.length"
      :title="`您尚未填写${missingFields.join('、')}，请补全个人信息后保存。`"
      type="warning"
      show-icon
      :closable="false"
      style="margin: 16px; width: auto"
    />
    <user-profile />
  </lzd-modal>
</template>

<script lang="ts" setup>
  import { computed, ref } from 'vue';
  import { useUserStore } from '@/store/modules/user';
  import UserProfile from '@/views/user/profile/index.vue';
  const userStore = useUserStore();
  const missingFields = computed(() => {
    const fields: string[] = [];
    const user = userStore.personalInfo;
    if (user?.category === 1 && !user.job?.trim()) fields.push('职称');
    if (!user?.sign?.trim()) fields.push('签名');
    return fields;
  });
  /** 弹窗是否打开 */
  const visible = defineModel({ type: Boolean });

  /** 提交loading */
  const loading = ref<boolean>(false);

  const handleClosed = () => {
    loading.value = false;
  };
</script>
